import React from 'react';
import SearchableSelect from '../../SearchableSelect';
import { SelectFilterField } from '../types';

export type SelectFieldProps = {
  field: SelectFilterField;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  /** Em popovers/modais, abre o menu em portal para não ficar atrás do rodapé */
  inOverlay?: boolean;
};

const SelectField: React.FC<SelectFieldProps> = ({
  field,
  value,
  onChange,
  disabled,
  inOverlay = false
}) => {
  return (
    <SearchableSelect
      options={field.options}
      value={value || ''}
      onChange={onChange}
      placeholder={field.placeholder || 'Selecione'}
      loading={field.loading}
      disabled={disabled}
      fluid
      clearable={field.clearable !== false}
      openUpward={false}
      menuPortal={inOverlay}
    />
  );
};

export default SelectField;
